import { render } from "./as-tabMenu.vue?vue&type=template&id=0e112aa1&scoped=true&ts=true"
import script from "./as-tabMenu.vue?vue&type=script&lang=ts"
export * from "./as-tabMenu.vue?vue&type=script&lang=ts"

import "./as-tabMenu.vue?vue&type=style&index=0&id=0e112aa1&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e112aa1"]])

export default __exports__